// extracted by mini-css-extract-plugin
export default {"AccordionPanelTitle":"AccordionPanelTitle__AccordionPanelTitle___AEEJ3"};